export const SET_SEARCH_DATA = 'SET_SEARCH_DATA';
export const SEARCH_TRAINS = 'SEARCH_TRAINS';
export const TRAIN_ROUTE = 'TRAIN_ROUTE';
export const SORT_SELECTED = 'SORT_SELECTED';
export const FETCH_AVAILABILITY_RESPONSE_ALREADY_PRESENT = 'FETCH_AVAILABILITY_RESPONSE_ALREADY_PRESENT';
export const FETCH_AVAILABILITY_SET_ERROR = 'FETCH_AVAILABILITY_SET_ERROR';
export const FETCH_AVAILABILITY_REMOVE_ERROR = 'FETCH_AVAILABILITY_REMOVE_ERROR';
export const FETCH_AVAILABILITY_SET_LOADER = 'FETCH_AVAILABILITY_SET_LOADER';
export const BOARDING_STATIONS = 'BOARDING_STATIONS';
export const FETCH_TRAVELLERS = 'FETCH_TRAVELLERS';
export const LOAD_TRAVELLERS = 'LOAD_TRAVELLERS';
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const ADD_FORM = 'ADD_FORM';
export const UPDATE_BOARDING_STATION = 'UPDATE_BOARDING_STATION';
export const BOOKING_DETAILS = 'BOOKING_DETAILS';
export const UPDATE_RESERVATION_CHOICE = 'UPDATE_RESERVATION_CHOICE';
export const UPDATE_USER_DETAIL = 'UPDATE_USER_DETAIL';
export const UPDATE_TRIP_TAG_DETAILS = 'UPDATE_TRIP_TAG_DETAILS';
export const TOGGLE_PREFERENCE = 'TOGGLE_PREFERENCE';
export const TOGGLE_INSURANCE = 'TOGGLE_INSURANCE';
export const USER_STATUS = 'USER_STATUS';
export const USER_FORGOT_DETAILS = 'USER_FORGOT_DETAILS';
export const USER_UPDATE_IRCTC_ID = 'USER_UPDATE_IRCTC_ID';
export const USER_GET_OTP = 'USER_GET_OTP';
export const USER_VERIFY_OTP = 'USER_VERIFY_OTP';
export const STATIONS_AUTO_COMPLETE = 'STATIONS_AUTO_COMPLETE';
export const SOURCE_AUTO_COMPLETE = 'SOURCE_AUTO_COMPLETE';
export const DESTINATION_AUTO_COMPLETE = 'DESTINATION_AUTO_COMPLETE';
export const FILLING_TRAINS_QUERY_DATA = 'FILLING_TRAINS_QUERY_DATA';
export const BOOKING_REVIEW = 'BOOKING_REVIEW';
export const IRCTC_BOOKING_ID = 'IRCTC_BOOKING_ID';
export const LOG_IN = 'LOG_IN';
export const SHOW_ERROR = 'SHOW_ERROR';
export const FILL_USER_DATA = 'FILL_USER_DATA';
export const CHANGE_USER_DATA = 'CHANGE_USER_DATA';
export const SHOW_ERROR_ON_NEW_ACCOUNT = 'SHOW_ERROR_ON_NEW_ACCOUNT';
export const TOGGLE_CHOICE = 'TOGGLE_CHOICE';
export const ACTION_SET_SESSION_ID_AND_CAPTCHA = 'ACTION_SET_SESSION_ID_AND_CAPTCHA';
export const FILL_DATA_FROM_PINCODE = 'FILL_DATA_FROM_PINCODE';
export const FILL_USERNAME = 'FILL_USERNAME';
export const FILL_EMAIL = 'FILL_EMAIL';
export const FILL_MOBILE = 'FILL_MOBILE';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
export const ADD_COUPON = 'ADD_COUPON';
export const REMOVE_COUPON = 'REMOVE_COUPON';
export const CHANGE_SELECTED_COUPON = 'CHANGE_SELECTED_COUPON';
export const ADD_RECOMMENDED_COUPONS = 'ADD_RECOMMENDED_COUPONS';
export const SELECT_TRAVEL_ADVISORY_POLICY = 'SELECT_TRAVEL_ADVISORY_POLICY';
export const UNSELECT_TRAVEL_ADVISORY_POLICY = 'UNSELECT_TRAVEL_ADVISORY_POLICY';
export const SET_ADDRESS_LINE1 = 'SET_ADDRESS_LINE1';
export const SET_ERROR_ADDL1 = 'SET_ERROR_ADDL1';
export const SET_ADDRESS_LINE2 = 'SET_ADDRESS_LINE2';
export const SET_ERROR_ADDL2 = 'SET_ERROR_ADDL2';
export const SET_ADDRESS_LINE3 = 'SET_ADDRESS_LINE3';
export const SET_ERROR_ADDL3 = 'SET_ERROR_ADDL3';
export const SET_PINCODE= 'SET_PINCODE';
export const SET_STATE= 'SET_STATE';
export const SET_CITY= 'SET_CITY';
export const SET_POST_OFFICE= 'SET_POST_OFFICE';
export const SET_ADDRESS_BY_PIN= 'SET_ADDRESS_BY_PIN';
export const SET_ERROR_PINNO = 'SET_ERROR_PINNO';
export const SET_ERROR_IRCTC_USER_ID = 'SET_ERROR_IRCTC_USER_ID';
export const SET_POST_OFFICE_LIST = 'SET_POST_OFFICE_LIST';
export const GET_ADDRESS_FROM_LS = 'traveller/GET_ADDRESS_FROM_LS';
export const ACTION_SET_CONFIRM_OPTIONS = 'ACTION_SET_CONFIRM_OPTIONS';
export const ACTION_INIT_RAILS_LISTING_FILTERS = 'ACTION_INIT_RAILS_LISTING_FILTERS';
export const ACTION_SET_QUICK_FILTER = 'ACTION_SET_QUICK_FILTER';
export const ACTION_SET_FILTER = 'ACTION_SET_FILTER';
export const ACTION_COMMIT_TRAIN_AND_FILTER = 'ACTION_COMMIT_TRAIN_AND_FILTER';
export const ACTION_SET_LISTING_QUICK_FILTER = 'ACTION_SET_LISTING_QUICK_FILTER';
export const ACTION_INIT_FILTER_STATE = 'ACTION_INIT_FILTER_STATE';
export const ACTION_SET_TO_PREV_FILTER_STATE = 'ACTION_SET_TO_PREV_FILTER_STATE';
export const ACTION_CLEAR_ALL_FILTERS_ON_FILTER_PAGE = 'ACTION_CLEAR_ALL_FILTERS_ON_FILTER_PAGE';
export const ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE = 'ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE';
export const ACTION_FETCH_ALTERNATE_AVAILIBILITY = 'ACTION_FETCH_ALTERNATE_AVAILIBILITY';
export const ACTION_CLEAR_ALTERNATE_AVAILIBILITY = 'ACTION_CLEAR_ALTERNATE_AVAILIBILITY';
export const ACTION_SHOW_USER_ID_MODAL = 'ACTION_SHOW_USER_ID_MODAL';
export const ACTION_HIDE_USER_ID_MODAL = 'ACTION_HIDE_USER_ID_MODAL';
export const ACTION_SET_FREE_CANCELLATION = 'ACTION_SET_FREE_CANCELLATION';
export const ACTION_FREE_CANCELLATION_RESPONSE = 'ACTION_FREE_CANCELLATION_RESPONSE';
export const INITIALIZE_FILTER_OBJECT = "INITIALIZE_FILTER_OBJECT";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const APPLY_FILTER = "APPLY_FILTER";
export const ACTION_CLEAR_QUICK_FILTERS_ON_LISTING_PAGE ="ACTION_CLEAR_QUICK_FILTERS_ON_LISTING_PAGE";
export const ACTION_RAILOFY_RESPONSE = 'ACTION_RAILOFY_RESPONSE';
export const SAVE_RAILOFY_OPTIONS = '@mmt/SAVE_RAILOFY_OPTIONS';
export const ACTION_ON_SELECT_CNFM_GUARANTEE = '@mmt/ACTION_ON_SELECT_CNFM_GUARANTEE';
export const ACTION_RAILOFY_ERROR = '@mmt/ACTION_RAILOFY_ERROR';
export const ACTION_ZCSHOW_ERROR = '@mmt/ACTION_ZCSHOW_ERROR';
export const ACTION_FC_TG_FIRST_SELECTION = '@mmt/ACTION_FC_TG_FIRST_SELECTION';
export const ACTION_RAILOFY_LOADING = '@mmt/ACTION_RAILOFY_LOADING';
export const ACTION_VALIDATING_COUPON = 'VALIDATING_COUPON';
export const ACTION_SET_OR_RESET_LOGIN_MODAL = 'ACTION_SET_OR_RESET_LOGIN_MODAL';
export const AB_CONFIG_SET = 'AB_CONFIG_SET';
export const AB_CONFIG_FETCH_FAILED = 'AB_CONFIG_FETCH_FAILED';
export const SHOW_GSTIN_COMPONENT = 'SHOW_GSTIN_COMPONENT';
export const GSTIN_STATE = 'GSTIN_STATE';
export const GSTIN_USERCONSENT = 'GSTIN_USERCONSENT';
export const GSTIN_USERCONSENT_ERROR = 'GSTIN_USERCONSENT_ERROR';
export const GSTIN_STATE_ERROR = 'GSTIN_STATE_ERROR';
